import React, { Component } from 'react';
import {
  Form,
  Input,
  Label,
  Button,
  SelectTags,
  Textarea,
  Dropdown
} from '../../../Form';

import withTranslations from '../../../../utils/translations/withTranslations';

class Anamnese extends Component {
  constructor(...props) {
    super(...props);

    this.state = {
      isValid: true
    };
  }

  next() {
    this.props.saveItem(this.form.formData());
    this.props.next();
  }

  render() {
    const { translate, data = {}, previous } = this.props;
    const { isValid } = this.state;

    return (
      <div className="Anamnese">
        <Form
          ref={form => (this.form = form)}
          onValidationChange={valid => this.setState({ isValid: valid })}
          className="Anamnese__Form"
        >
          <h1>{translate('fiche.anamnese.title')}</h1>

          <Label text={translate('fiche.anamnese.glasses')} />
          <Dropdown
            name="glasses"
            data={[
              { value: '1', label: translate('yes') },
              { value: '0', label: translate('no') }
            ]}
            rules={['required']}
            defaultValue={data.glasses}
          />

          <Label text={translate('fiche.anamnese.contact_lenses')} />
          <Dropdown
            name="contact_lenses"
            data={[
              { value: '1', label: translate('yes') },
              { value: '0', label: translate('no') }
            ]}
            rules={['required']}
            defaultValue={data.contact_lenses}
          />

          <Label text={translate('fiche.anamnese.family_antecedents')} />
          <SelectTags
            name="family_antecedents"
            tags={translate('fiche.anamnese.family_antecedents_choices')}
            defaultValue={data.family_antecedents}
          />

          <Label text={translate('fiche.anamnese.personal_antecedents')} />
          <SelectTags
            name="personal_antecedents"
            tags={translate('fiche.anamnese.personal_antecedents_choices')}
            defaultValue={data.personal_antecedents}
          />

          <Label text={translate('fiche.anamnese.allergies')} />
          <Input name="allergies" defaultValue={data.allergies} />

          <Label text={translate('fiche.anamnese.traumatic')} />
          <Input name="traumatic" defaultValue={data.traumatic} />

          <Label text={translate('fiche.anamnese.operations')} />
          <Input name="operations" defaultValue={data.operations} />

          <Label text={translate('fiche.anamnese.previous_investigations')} />
          <Input
            name="previous_investigations"
            defaultValue={data.previous_investigations}
          />

          <Label text={translate('fiche.anamnese.accidents_last_season')} />
          <Input
            name="accidents_last_season"
            defaultValue={data.accidents_last_season}
          />

          <Label text={translate('fiche.anamnese.invalidity_card')} />
          <Textarea
            name="invalidity_card"
            defaultValue={data.invalidity_card}
          />

          <Button
            solid
            className="Form__Button"
            disabled={!isValid}
            onClick={() => this.next()}
          >
            {translate('fiche.next')}
          </Button>
          <Button
            transparant
            className="Form__Button"
            onClick={() => previous()}
          >
            {translate('fiche.previous')}
          </Button>
        </Form>
      </div>
    );
  }
}

export default withTranslations(Anamnese);
